var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8943 8.78631H20.1224V8.75H11.4974V12.25H16.9134C16.1233 14.2874 14.0001 15.75 11.4974 15.75C8.32196 15.75 5.7474 13.3993 5.7474 10.5C5.7474 7.60069 8.32196 5.25 11.4974 5.25C12.9632 5.25 14.2967 5.75487 15.312 6.57956L18.0227 4.10462C16.3111 2.64819 14.0216 1.75 11.4974 1.75C6.205 1.75 1.91406 5.66781 1.91406 10.5C1.91406 15.3322 6.205 19.25 11.4974 19.25C16.7898 19.25 21.0807 15.3322 21.0807 10.5C21.0807 9.91331 21.0146 9.34063 20.8943 8.78631Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02344 6.42731L6.17204 8.53562C7.024 6.60975 9.08729 5.25 11.5018 5.25C12.9676 5.25 14.3011 5.75487 15.3165 6.57956L18.0271 4.10462C16.3155 2.64819 14.0261 1.75 11.5018 1.75C7.82085 1.75 4.62865 3.64744 3.02344 6.42731Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5003 19.2498C13.9757 19.2498 16.2249 18.3849 17.9255 16.9783L14.9594 14.6867C13.9649 15.3772 12.7497 15.7507 11.5003 15.7498C9.00769 15.7498 6.89121 14.2986 6.09387 12.2734L2.96875 14.4719C4.55479 17.3056 7.77575 19.2498 11.5003 19.2498Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8969 8.78631H20.125V8.75H11.5V12.25H16.916C16.5381 13.2197 15.8572 14.067 14.9577 14.6873L14.9591 14.6864L17.9251 16.9781C17.7153 17.1522 21.0833 14.875 21.0833 10.5C21.0833 9.91331 21.0172 9.34063 20.8969 8.78631Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.53f3a78bdffa4587030b2969bec4bc8e.svg";
export { ForwardRef as ReactComponent };